import mainLogo from '../main-logo.avif';
import crLogo from '../cr.png';

export type LogoType = 'main' | 'cr';

export interface LogoConfig {
  type: LogoType;
  src: string;
  alt: string;
  size: string;
  headerColor: string;
  buttonColors: {
    active: string;
    inactive: string;
    hover: string;
  };
}

// Change this to switch between logos
// You can also set REACT_APP_LOGO_TYPE environment variable
const CURRENT_LOGO: LogoType = (process.env.REACT_APP_LOGO_TYPE as LogoType) || 'main';

export const logoConfig: Record<LogoType, LogoConfig> = {
  main: {
    type: 'main',
    src: mainLogo,
    alt: 'DDQ Logo',
    size: 'h-8', // Small size for main logo
    headerColor: 'bg-adalabs-blue-500 border-adalabs-blue-600', // Blue theme
    buttonColors: {
      active: 'bg-white text-adalabs-blue-700',
      inactive: 'text-white hover:text-white hover:bg-adalabs-blue-600',
      hover: 'hover:bg-adalabs-blue-600'
    }
  },
  cr: {
    type: 'cr',
    src: crLogo,
    alt: 'CR Logo',
    size: 'h-12', // Larger size for CR logo
    headerColor: 'bg-white border-gray-300', // White theme
    buttonColors: {
      active: 'bg-blue-800 text-white',
      inactive: 'text-gray-700 border border-transparent hover:text-adalabs-blue-500 hover:bg-white hover:border-adalabs-blue-500',
      hover: 'hover:bg-white hover:text-adalabs-blue-500 hover:border-adalabs-blue-500'
    }
  }
};

export const getCurrentLogo = (): LogoConfig => {
  return logoConfig[CURRENT_LOGO];
};

// Helper function to easily switch logos
export const switchLogo = (logoType: LogoType): void => {
  // This would typically be used with environment variables or a config file
  // For now, you can manually change CURRENT_LOGO above
  console.log(`Switching to ${logoType} logo`);
};

// Quick access functions
export const useMainLogo = () => logoConfig.main;
export const useCrLogo = () => logoConfig.cr;

// Validate logo type
export const isValidLogoType = (type: string): type is LogoType => {
  return type === 'main' || type === 'cr';
};

// Available color schemes for headers:
// Blue: 'bg-blue-500 border-blue-600'
// Red: 'bg-red-600 border-red-700'
// Green: 'bg-green-500 border-green-600'
// Purple: 'bg-purple-600 border-purple-700'
// Gray: 'bg-gray-600 border-gray-700'
// White: 'bg-white border-gray-300'
// Custom: 'bg-adalabs-blue-500 border-adalabs-blue-600'

// Button color examples:
// For dark headers: active: 'bg-white text-blue-700', inactive: 'text-white hover:bg-blue-600'
// For light headers: active: 'bg-gray-800 text-white', inactive: 'text-gray-700 hover:bg-gray-100'
